import { useState } from "react";
import { faqs } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        eyebrow="常见问题"
        title="吃瓜之前，你可能想先问这几件事"
        desc="关于内容真伪、投稿材料与隐私处理，我们把被问得最多的五个问题整理在下面。"
      />

      <div className="grid gap-6 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
                  >
                    <span className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="text-sm font-medium text-foreground-900 md:text-[15px]">
                        {item.q}
                      </span>
                    </span>
                    <span
                      className={`flex h-5 w-5 shrink-0 items-center justify-center transition-transform ${
                        isOpen ? "rotate-180 text-primary-600" : "text-foreground-400"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </button>
                  {isOpen ? (
                    <div className="px-4 pb-4 md:px-5">
                      <p className="pl-8 text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                        {item.a}
                      </p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-lg border border-secondary-200/70 bg-secondary-50 p-4 md:p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-question-answer-line text-xl"></i>
            </span>
            <h3 className="mt-4 text-base font-semibold text-foreground-900">还有别的问题？</h3>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-700">
              投稿流程、材料打码、澄清申请……只要和站内内容有关，都可以直接留言给我们，
              工作日内会逐条回复。
            </p>
            <a
              href="#subscribe"
              className="mt-4 inline-flex cursor-pointer items-center gap-1.5 rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-opacity hover:opacity-90 whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i>
              给我们留言
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}